class Payroll {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.employeeId = data.employeeId || null;
      this.month = data.month || '';
      this.year = data.year || new Date().getFullYear();
      this.basicSalary = data.basicSalary || 0;
      this.allowances = data.allowances || 0;
      this.bonuses = data.bonuses || 0;
      this.deductions = data.deductions || 0;
      this.tax = data.tax || 0;
      this.netSalary = data.netSalary || 0;
      this.workingDays = data.workingDays || 0;
      this.presentDays = data.presentDays || 0;
      this.leaveDays = data.leaveDays || 0;
      this.overtime = data.overtime || 0;
      this.status = data.status || 'Draft';
      this.paidDate = data.paidDate || null;
      this.paymentMethod = data.paymentMethod || 'Bank Transfer';
      this.remarks = data.remarks || '';
      this.createdAt = data.createdAt || new Date().toISOString();
    }
  
    getStatusColor() {
      const colors = { 'Draft': '#6b7280', 'Pending': '#f59e0b', 'Paid': '#10b981', 'Failed': '#ef4444' };
      return colors[this.status] || '#6b7280';
    }
  
    calculateGrossSalary() {
      return this.basicSalary + this.allowances + this.bonuses;
    }
  
    calculateNetSalary() {
      return this.calculateGrossSalary() - this.deductions - this.tax;
    }
  
    validate() {
      const errors = [];
      if (!this.employeeId) errors.push('Employee is required');
      if (!this.month) errors.push('Month is required');
      if (!this.year) errors.push('Year is required');
      if (this.basicSalary <= 0) errors.push('Basic salary must be greater than 0');
      return { isValid: errors.length === 0, errors };
    }
  
    toJSON() { return { ...this }; }
    static fromJSON(json) { return new Payroll(json); }
  }
  export default Payroll;